// extracted by mini-css-extract-plugin
module.exports = {"root":"_3c900eb"};